import { render } from "./LuckyWheel.vue?vue&type=template&id=1183cc75&scoped=true"
import script from "./LuckyWheel.vue?vue&type=script&lang=js"
export * from "./LuckyWheel.vue?vue&type=script&lang=js"

import "./LuckyWheel.vue?vue&type=style&index=0&id=1183cc75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1183cc75"]])

export default __exports__